import { render, staticRenderFns } from "./Dipres.vue?vue&type=template&id=05be99fa&scoped=true&"
var script = {}
import style0 from "./Dipres.vue?vue&type=style&index=0&id=05be99fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05be99fa",
  null
  
)

export default component.exports